import { Link } from "react-router-dom";
import type { Collection } from "@/mocks/guagua";

interface Props {
  item: Collection;
  highlight?: boolean;
}

export default function CollectionCard({ item, highlight = false }: Props) {
  return (
    <article
      className={`group flex h-full flex-col overflow-hidden rounded-lg border bg-background-50 transition-colors ${
        highlight ? "border-primary-300" : "border-background-200 hover:border-primary-300"
      }`}
    >
      <Link to={`/collection/${item.id}`} className="block">
        <div className="relative h-44 w-full overflow-hidden md:h-48">
          <img
            src={item.cover}
            alt={`${item.title} 合集配图`}
            title={`${item.title} - 吃瓜合集导航`}
            className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
          />
          <span className="absolute left-3 top-3 rounded-full bg-background-50/95 px-3 py-1 text-xs font-medium text-primary-700">
            {item.categoryName}
          </span>
        </div>
      </Link>

      <div className="flex flex-1 flex-col p-4 md:p-5">
        <div className="flex items-center gap-3 text-xs text-foreground-500">
          <span className="inline-flex items-center gap-1 font-medium text-primary-600">
            <i className="ri-fire-fill leading-none" aria-hidden="true"></i>
            {item.heat} 热度
          </span>
          <span className="h-1 w-1 rounded-full bg-foreground-300" aria-hidden="true"></span>
          <span>{item.date} 更新</span>
        </div>

        <h3 className="mt-2.5 font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
          <Link to={`/collection/${item.id}`} className="transition-colors hover:text-primary-700">
            {item.title}
          </Link>
        </h3>

        <p className="mt-2 line-clamp-3 flex-1 text-sm leading-relaxed text-foreground-600">{item.summary}</p>

        <div className="mt-4 flex flex-wrap gap-1.5">
          {item.tags.map((tag) => (
            <span key={tag} className="rounded-full bg-secondary-100 px-2.5 py-1 text-xs text-secondary-900">
              #{tag}
            </span>
          ))}
        </div>

        <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3.5">
          <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500">
            <i className="ri-time-line leading-none" aria-hidden="true"></i>
            约 {item.readTime}
          </span>
          <Link
            to={`/collection/${item.id}`}
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-700 transition-all hover:gap-2"
          >
            看合集
            <i className="ri-arrow-right-line leading-none" aria-hidden="true"></i>
          </Link>
        </div>
      </div>
    </article>
  );
}